<template>
  <div class="page-container">
    <div class="content-wrap">
    <TopNavBar
      v-bind:secondTierLoadingDone="true"/>
    <b-container fluid class="ga-text-page-container">
      <b-row>
        <b-col class="d-none d-md-block col-md-1 col-lg-2"></b-col>
        <b-col class="col-12 col-md-10 col-lg-8">
          <article class="ga-text-page">
            <div v-html="manual" class="ga-text-page__body"></div>
          </article>
        </b-col>
      </b-row>
    </b-container>
    </div>
    <GenderAppFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import TopNavBar from '../components/TopNavBar'
import GenderAppFooter from '../components/Footer'
import { SiteManagerService } from '../services/siteManagerService'

export default {
  name: 'Manual',
  // insert the following code for vue-meta to work
  metaInfo () {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: this.description
        },
        {
          property: 'og:title',
          vmid: 'og:title',
          content: this.title
        },
        {
          property: 'og:description',
          vmid: 'og:description',
          content: this.description
        },
        {
          property: 'og:url',
          vmid: 'og:url',
          content: this.canonicalUrl
        },
        {
          name: 'twitter:title',
          vmid: 'twitter:title',
          content: this.title
        },
        {
          name: 'twitter:description',
          vmid: 'twitter:description',
          content: this.description
        }
      ],
      link: [
        { rel: 'canonical', href: this.canonicalUrl }
      ]
    }
  },
  components: {
    GenderAppFooter,
    TopNavBar
  },
  data () {
    return {
      manual: '',
      title: 'Handbuch · gender app',
      description: 'Hilfe bei Fragen zu gender app',
      canonicalUrl: 'https://genderapp.org/manual'
    }
  },
  methods: {
    getSiteManager () {
      SiteManagerService.getListViewData('', 'all')
        .then((response) => {
          this.manual = response.data.results[0].manual
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getSiteManager()
  }
}
</script>
